import { Listener, ILogMessage } from '@bingads-webui/listener';
import _ from 'underscore';

import { IInMemoryListenerOptions, ISink } from '../types';

/**
 * In memory listener class. This logs to an in-memory object that is passed
 * in. It expects a sink object with write method on it.
 */

export class InMemoryListener extends Listener {
  sink: ISink;

  /**
   * Creates an instance of InMemoryListener.
   * @param {IInMemoryListenerOptions} [options={}] - The options for in-memory listener
   */
  constructor(options: IInMemoryListenerOptions = {}) {
    super();

    this.formatters = options.formatters || {};
    this.filters = options.filters || {};
    this.sink = options.sink;
  }

  /**
   * Init in memory listener if needed options passed in
   * @returns {undefined} - no returns
   */
  init() {
    if (this.sink && _.isFunction(this.sink.write)) {
      this.initialized = true;
    }
  }

  /**
   * writes logs to the listener
   * @param {object} logMessage - logs to be written
   * @returns {undefined} - no returns
   */
  write(logMessage: ILogMessage) {
    if (!this.initialized || this.filterLogs(logMessage)) {
      return;
    }

    const formattedMsg = this.formatLogs(logMessage);

    this.sink.write(formattedMsg);
  }
}
